import * as React from "react";
import { Card, SkeletonLoader, Stack, useTheme } from "@bookingcom/bui-react";
export const SkeletonFlightCard = ({ shorterCard }) => {
    const theme = useTheme();
    return (React.createElement(Card, null,
        React.createElement(Stack, { gap: 6 },
            React.createElement(Stack, null,
                React.createElement(Stack, { gap: 6, direction: "row" },
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(SkeletonLoader, null)),
                    React.createElement(SkeletonLoader, { width: theme.units.spacing_12x })),
                React.createElement(Stack, { gap: 6, direction: "row" },
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(SkeletonLoader, null)),
                    React.createElement(SkeletonLoader, { width: theme.units.spacing_12x })),
                shorterCard && (React.createElement(Stack, { gap: 6, direction: "row" },
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(SkeletonLoader, null)),
                    React.createElement(SkeletonLoader, { width: theme.units.spacing_12x })))),
            !shorterCard && (React.createElement(Stack, { gap: 6, direction: "row" },
                React.createElement(Stack.Item, { grow: true },
                    React.createElement(SkeletonLoader, null)),
                React.createElement(SkeletonLoader, { width: theme.units.spacing_12x }))),
            React.createElement(Stack, { gap: 6, direction: "row", justifyContent: "space-between", alignItems: "end" },
                React.createElement(SkeletonLoader, { variant: "box", width: theme.units.spacing_8x }),
                React.createElement(SkeletonLoader, { width: "30%" })))));
};
